export const irfConfig = {
  publicationTab: [
    '01A',
    '01B',
    '01',
    '02',
    '03',
    '04',
    '04A',
    '04B',
    '05',
    '11',
  ],
  projectTab: ['00'],
  presentationTab: ['06'],
  supervisedThesesTab: ['11'],
  othersTab: ['07', '09', '10', '12', '13', '14', '99'],
};

/**
 * Creates an ordered array of all type codes based on IrfConfig priority
 * This ensures consistent ordering when grouping publications by type
 */
export const getOrderedTypeCodes = (): string[] => {
  return Array.from(
    new Set([
      ...irfConfig.publicationTab,
      ...irfConfig.projectTab,
      ...irfConfig.presentationTab,
      ...irfConfig.supervisedThesesTab,
      ...irfConfig.othersTab,
    ]),
  );
};

/**
 * Maps type codes to their corresponding descriptive message keys for group titles
 * This consolidates related types under a single descriptive message key
 */
const TYPE_CODE_MESSAGE_MAP: Record<string, string> = {
  // Projects
  '00': 'Projects',

  // Journal, magazine, or newspaper articles
  '01': 'Articles',
  '01A': 'Articles',
  '01B': 'Articles',

  // Monographs
  '02': 'Monographs',

  // Edited collections
  '03': 'Collections',

  // Book parts or conference papers
  '04': 'BookParts',
  '04A': 'BookParts',
  '04B': 'BookParts',

  // Research reports or working papers
  '05': 'Reports',

  // Presentations
  '06': 'Presentations',

  // Student theses
  '11': 'Theses',

  // Others category
  '07': 'AudioVideo',
  '09': 'Software',
  '10': 'WebPublications',
  '12': 'Patents',
  '13': 'Exhibitions',
  '14': 'ExhibitionContributions',
  '99': 'Other',
} as const;

/**
 * Maps type codes to their corresponding descriptive message keys for group titles
 * @param typeCode - The publication type code (e.g., '01', '01A', '02', etc.)
 * @returns The descriptive message key for translation or 'Other' as fallback
 */
export const getGroupTitleMessageKey = (typeCode: string): string => {
  return TYPE_CODE_MESSAGE_MAP[typeCode] ?? 'Other';
};
